module.exports = __webpack_public_path__ + "img/Artboard6.25d26eea.webp";